import uuid from 'react-uuid';
import { stringconstants } from '../constants';
import {
  convertStringToDate,
  getFutureDateBasedOnMonths,
  isValidUrl,
  encryptPayload,
  evaluateMemberFilter, getCurrentPage,
} from '../utils/util';
import { validateDlsInput } from '../Validations/Validations';

const getVal = require('lodash/get');

export const filterMemberDetails = ({
  memberFilter,
  lMemberDetails,
  params,
  loggerApiCall,
  errorStrings,
}) => {
  let filteredOptions = [...lMemberDetails];
  memberFilter.forEach((filter) => {
    switch (filter.type) {
      case 'staticArray': {
        filteredOptions = filteredOptions.filter((member) => {
          const valueToCompare = getVal(member, filter.criteriaCompareTo);
          let eligible = false;
          let breakLoop = false;
          if (Array.isArray(valueToCompare) && valueToCompare !== null) {
            /* eslint-disable no-restricted-syntax -- need */
            for (const element of valueToCompare) {
              /* eslint-disable max-len -- need */
              ({ eligible, breakLoop } = evaluateMemberFilter(filter, element, eligible, breakLoop));
              /* eslint-enable max-len -- need */
              if (breakLoop) {
                break;
              }
            }
            /* eslint-enable no-restricted-syntax -- need */
          } else {
            ({ eligible } = evaluateMemberFilter(filter, valueToCompare));
          }
          if (eligible) {
            return member;
          }
          return null;
        });
        break;
      }
      case 'urlParam': {
        const filterCriteria = getVal(params, filter.criteriaName);
        filteredOptions = filteredOptions.filter((member) => {
          let eligible = false;
          const valueToCompare = getVal(member, filter.criteriaCompareTo);
          if (filter.valueToBeComparedToIS === 'array') {
            valueToCompare.forEach((type) => {
              if (type === filterCriteria) {
                eligible = true;
              }
            });
          } else if (valueToCompare === filterCriteria) eligible = true;
          if (eligible) {
            return member;
          }
          return null;
        });
        break;
      }
      case 'lookup': {
        const lookupValue = getVal(params, filter.fieldToLookup);
        if (filter.valuesToMap[lookupValue]) {
          filteredOptions = filteredOptions.filter((member) => {
            let isCardValid = false;
            let firstCheckDone = false;
            filter.valuesToMap[lookupValue].forEach((lookupFilter) => {
              const allowedValue = getVal(member, lookupFilter.criteria);
              if (
                !firstCheckDone
                && lookupFilter.allowedValues.includes(allowedValue)
              ) {
                isCardValid = true;
              } else if (
                firstCheckDone
                && isCardValid
                && !lookupFilter.allowedValues.includes(allowedValue)
              ) isCardValid = false;
              firstCheckDone = true;
            });
            if (isCardValid) {
              return member;
            }
            return null;
          });
        }
        break;
      }
      case 'memberDateVerification': {
        const errorStrs = [];
        filteredOptions = filteredOptions.filter((member) => {
          const resultsOfConditons = [];
          if (filter.conditions && filter.conditions.length > 1) {
            filter.conditions.forEach((cond) => {
              switch (cond.condition) {
                case 'greaterThan': {
                  const dateToCompare = convertStringToDate(
                    getVal(member, cond.dateToCompare)
                  );
                  const maxStartDate = convertStringToDate(cond.maxStartDate);
                  resultsOfConditons.push(dateToCompare > maxStartDate);
                  if (!(dateToCompare > maxStartDate)) {
                    errorStrs.push(
                      `${errorStrings.invalidAccountSetupDate}: ${getVal(
                        member,
                        cond.dateToCompare
                      )}`
                    );
                  }
                  break;
                }
                case 'dateRangeInMonths': {
                  const dateToCompareStr = getVal(member, cond.dateToCompare);
                  const dateRangeBtwMonths = cond.submitDateRange;
                  const startDate = getFutureDateBasedOnMonths(
                    dateToCompareStr,
                    dateRangeBtwMonths[0]
                  );
                  const endDate = getFutureDateBasedOnMonths(
                    dateToCompareStr,
                    dateRangeBtwMonths[1]
                  );
                  const today = new Date();
                  resultsOfConditons.push(
                    today > startDate && today <= endDate
                  );
                  if (!(today > startDate && today <= endDate)) {
                    errorStrs.push(
                      `${errorStrings.failedWithDateRange}: ${dateToCompareStr}`
                    );
                  }
                  break;
                }
                default:
                  break;
              }
            });
          }
          if (filter.conditionType === 'AND') {
            if (resultsOfConditons.every((b) => b === true)) {
              return member;
            }
          }
          return null;
        });
        if (filteredOptions.length === 0) {
          const logString = `status=errorSettingMemberDetails  response=${errorStrs.join(
            ', '
          )}`;
          loggerApiCall(logString, 'error');
        }
        break;
      }
      case 'supplementaryCardFilters': {
        filteredOptions = filteredOptions.filter((member) => {
          // if memeber has supplementary cards then filter these supp cards
          if (
            member.supplementaryAccounts
            && member.supplementaryAccounts.length > 0
          ) {
            const filteredSuppCards = filterMemberDetails({
              memberFilter: filter.suppFilters,
              lMemberDetails: member.supplementaryAccounts,
              params,
              loggerApiCall,
              errorStrings,
            });
            if (filteredSuppCards.length > 0) {
              member.supplementaryAccounts = [...filteredSuppCards];
              return member;
            }
            if (!filter.isSuppCardMandatory) {
              // if supplementary cards are optional then return member
              member.supplementaryAccounts = [];
              return member;
            }
            return null;
          }
          if (!filter.isSuppCardMandatory) {
            // if supplementary cards are optional then return member
            return member;
          }
          return null;
        });
        break;
      }
      default:
        return null;
    }
    return true;
  });
  return filteredOptions;
};

export const getParamsFromSessionStorage = (cuid, parentCuid = null) => {
  const iformSessionParamsObject = window.sessionStorage.getItem(
    'iformSessionParams'
  )
    ? JSON.parse(window.sessionStorage.getItem('iformSessionParams'))
    : {};
  if (iformSessionParamsObject[cuid]) {
    return iformSessionParamsObject[cuid];
  }
  if (parentCuid && iformSessionParamsObject[parentCuid]) {
    return iformSessionParamsObject[parentCuid];
  }
  return null;
};

export const mandatoryUrlParamsCheck = (mandatoryParams, params) => {
  let isUrlValid = true;
  mandatoryParams.forEach((key) => {
    if (
      !Object.prototype.hasOwnProperty.call(params, key)
      || params[key] === ''
    ) {
      isUrlValid = false;
    }
  });
  return isUrlValid;
};

export const validateUrlParams = (params, validationsToPerform) => {
  let isUrlValid = true;
  if (validationsToPerform) {
    /* eslint-disable no-restricted-syntax -- need */
    for (const key of Object.keys(validationsToPerform)) {
      const invalidMsg = validateDlsInput(
        params[key],
        validationsToPerform[key]
      );

      if (invalidMsg) {
        isUrlValid = false;
        break; // exits loop immediately
      }
    }
    /* eslint-enable no-restricted-syntax -- need */
  }
  return isUrlValid;
};

export const validateUrlParamsForValidUrlValue = (params, allowedHosts) => {
  let isValid = true;
  Object.keys(params).forEach((key) => {
    const value = params[key];
    // if value string is a valid url then host should be 'http://www.americanexpress.com'
    if (isValidUrl(value)) {
      const url = new URL(value);
      if (!allowedHosts.includes(url.host)) {
        isValid = false;
      }
    }
  });
  return isValid;
};

export const getErrorStrings = (container, params) => {
  const errorStrings = {
    invalidUrl: 'An Error has occurred, please open this link again.',
    noValidCardsFound:
      "Sorry, we couldn't find any valid card corresponding to your details for this journey.",
    failedMemberApiCall: 'Sorry, internal server error. Please try again later.',
    formDisableMessage: 'Sorry, this form is currently unavailable.',
    invalidCredentials: 'Access denied',
    userNotAllowed: 'Sorry, this link is not supported for your credentials.',
    failedMemberEmail: 'Sorry, internal server error. Please try again later.',
    failedDecryptApiCall: 'Sorry, internal server error. Please try again later.',
  };
  // override default error strings with json values
  if (container.errorStrings) {
    Object.entries(container.errorStrings).forEach(([key, value]) => {
      errorStrings[key] = value;
    });
  }

  if (container.dynamicErrorStrings && params) {
    // iterate through dynamic error string array
    container.dynamicErrorStrings.forEach((errStrObj) => {
      let val;
      if (errStrObj.valueFrom === stringconstants.params) {
        val = getVal(params, errStrObj.value);
      }
      const finalErrorStr = errorStrings[errStrObj.errorString].replace(
        errStrObj.key,
        val
      );
      errorStrings[errStrObj.errorString] = finalErrorStr;
    });
  }
  return errorStrings;
};

export const getAtWorkUserData = async ({ jId, memberApiUrls, cuid }) => {
  const requestOptions = {
    defer: true,
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      traceId: uuid(),
      journeyId: jId,
    },
  };

  const atWorkApi = `${memberApiUrls}/iForms/secure/atWork/email?cuid=${cuid}&page=${getCurrentPage()}`;
  const response = await fetch(`${atWorkApi}`, requestOptions);
  return response.json();
};

export const getLookupData = async ({
  type,
  payloadBody,
  jId,
  memberApiUrls,
  cuid,
}) => {
  // need to generate lookup payload
  const lookupPayload = {
    head: {
      traceId: uuid(),
      journeyId: jId,
      span: 'iForm6513',
    },
    body: payloadBody,
  };

  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: encryptPayload(lookupPayload),
  };

  const lookupApi = `${memberApiUrls}/iForms/secure/lookUp/${type}?cuid=${cuid}&page=${getCurrentPage()}`;
  const response = await fetch(`${lookupApi}`, requestOptions);
  let result;
  if (type === 'file') {
    const statusCode = response.status;
    let data;
    if (statusCode >= 200 && statusCode < 300) {
      data = await response.blob();
    } else {
      data = null;
    }
    result = { statusCode, data };
  } else {
    result = await response.json();
  }
  return result;
};

export const getRequiredData = async ({
  container,
  errorStrings,
  jId,
  memberApiUrls,
  setAtWorkUserData,
  setErrorMessage,
  cuid,
  loggerApiCall,
}) => {
  // if container and container[0].formContainer and container[0].formContainer.bypassAtWorkEmailApi
  if (container[0]?.formContainer?.bypassAtWorkEmailApi) {
    setAtWorkUserData({ atWorkBypass: true });
    return;
  }
  let logString = 'status=calledAtWorkEmailApi';
  loggerApiCall(logString, 'info');
  const atWorkApiResponse = await getAtWorkUserData({
    jId,
    memberApiUrls,
    cuid,
  });
  let requiredData = {}; // need to return this

  if (atWorkApiResponse && atWorkApiResponse.statusIndicator === 'T') {
    logString = 'status=atWorkEmailApiCallSuccess';
    loggerApiCall(logString, 'info');
    requiredData = { email: atWorkApiResponse.email };
    let remainingApiCalls = 0;
    if (
      container[0].formContainer.apisToCall
      && container[0].formContainer.apisToCall.length > 0
    ) {
      remainingApiCalls = container[0].formContainer.apisToCall.length;
      // considering all the api calls are async calls and not interdependent
      container[0].formContainer.apisToCall.forEach(async (apiToCall) => {
        switch (apiToCall.type) {
          case 'getLookupData':
            {
              // generate body for lookup request
              let payloadBody = {};
              if (apiToCall.lookupRequestStaticPayloadParams) {
                payloadBody = {
                  ...payloadBody,
                  ...apiToCall.lookupRequestStaticPayloadParams,
                };
              }
              if (
                apiToCall.lookupRequestDynamicPayloadParams
                && apiToCall.lookupRequestDynamicPayloadParams.length > 0
              ) {
                apiToCall.lookupRequestDynamicPayloadParams.forEach((param) => {
                  const val = getVal(requiredData, param.selectKey);
                  payloadBody = { ...payloadBody, [param.addAs]: val };
                });
              }
              let logString1 = `status=calledGetLookupDataApi type=${apiToCall.lookupRequestType}`;
              loggerApiCall(logString1, 'info');
              const apiResponse = await getLookupData({
                type: apiToCall.lookupRequestType,
                payloadBody,
                jId,
                memberApiUrls,
                cuid,
              });
              if (apiResponse && apiResponse.statusIndicator === 'T') {
                if (apiToCall.lookupRequestType === 'keyValue') {
                  const apiData = apiResponse.lookUpData;
                  requiredData = { ...requiredData, ...apiData };
                  logString1 = `status=getLookupDataApiCallSuccess type=${apiToCall.lookupRequestType}`;
                } else if (apiToCall.lookupRequestType === 'key') {
                  // need this call just to see if value is present or not
                  const { statusCode } = apiResponse;
                  if (statusCode === 200) {
                    requiredData = {
                      ...requiredData,
                      [apiToCall.dataStatusKey]: 'Yes',
                    };
                  } else if (statusCode === 206) {
                    requiredData = {
                      ...requiredData,
                      [apiToCall.dataStatusKey]: 'No',
                    };
                  }
                  logString1 = `status=getLookupDataApiCallSuccess type=${apiToCall.lookupRequestType}`;
                }
                loggerApiCall(logString1, 'info');
                remainingApiCalls -= 1;
              } else {
                logString1 = `status=getLookupDataApiCallFailed type=${apiToCall.lookupRequestType
                } message=${apiResponse.message
                  ? apiResponse.message
                  : 'failedToGetLookupData'
                }`;
                loggerApiCall(logString1, 'error');
                setErrorMessage(errorStrings.failedMemberApiCall);
              }
              if (remainingApiCalls === 0) {
                setAtWorkUserData({ ...requiredData });
              }
            }
            break;
          default:
            requiredData = { ...requiredData };
        }
      });
    }
    if (remainingApiCalls === 0) {
      setAtWorkUserData({ ...requiredData });
    }
  } else {
    setErrorMessage(errorStrings.failedMemberApiCall);
    setAtWorkUserData(null);
    logString = `status=atWorkEmailApiCallFailed message=${atWorkApiResponse.message ? atWorkApiResponse.message : 'failedToGetEmail'
    }`;
    loggerApiCall(logString, 'error');
  }
};

export const getCuidStatus = async ({
  memberApiUrls,
  pageType,
  urlPageType,
  jId,
  cuid,
  loggerApiCall,
  errorStrings,
  setErrorMessage,
}) => {
  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      traceId: uuid(),
      journeyId: jId,
    },
  };
  let logString;
  /* eslint-disable no-extra-parens -- need */
  const loginType = urlPageType === 'at-secure' ? 'atWork' : (pageType === 'secure' ? 'myca' : 'open');
  /* eslint-enable no-extra-parens -- need */
  const cuidStatusApi = `${memberApiUrls}/iForms/${pageType}/${loginType}/cuid/status?cuid=${cuid}&page=${getCurrentPage()}`;
  const response = await fetch(`${cuidStatusApi}`, requestOptions);
  if (response.status >= 200 && response.status < 300) {
    const result = await response.json();
    if (result && result.statusIndicator === 'T') {
      logString = 'status=cuidStatusApiCallSuccess';
      loggerApiCall(logString, 'info', {}, 'onLoad');
      return true;
    }
    logString = `status=cuidStatusApiCallFailed message=${result.message ? result.message : 'failedToGetCuidStatus'
    }`;
    loggerApiCall(logString, 'error', {}, 'onLoad');
    setErrorMessage(errorStrings.formDisableMessage);
    return false;
  }
  if (response.status === 401 || response.status === 498) {
    logString = `status=cuidStatusApiCallFailed message=invalidCredentials statusCode=${response.status}`;
    loggerApiCall(logString, 'error', {}, 'onLoad');
    setErrorMessage(errorStrings.invalidCredentials);
    return false;
  }
  logString = `status=cuidStatusApiCallFailed message=networkCallFailedWithStatus${response.status}`;
  loggerApiCall(logString, 'error', {}, 'onLoad');
  setErrorMessage(errorStrings.formDisableMessage);
  return false;
};

export const memberApiCall = async (props) => {
  const {
    memberCallQueryParams, params, memberApiUrls, jId, cuid,
  } = props;
  const requestOptions = {
    defer: true,
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      traceId: uuid(),
      journeyId: jId,
    },
  };
  let memberApi = `${memberApiUrls}/iForms/secure/member?cuid=${cuid}&page=${getCurrentPage()}`;
  if (memberCallQueryParams && memberCallQueryParams.length > 0) {
    // add these params in submit api
    memberCallQueryParams.forEach((queryParam) => {
      const key = queryParam;
      const val = encodeURIComponent(params[queryParam]);
      memberApi = `${memberApi}&${key}=${val}`;
    });
  }
  const response = await fetch(`${memberApi}`, requestOptions);
  return response.json();
};
